import { FilloutStandardEmbed } from "@fillout/react";

import { Box } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import { HEADING_FONT } from "@/css/constants";

import { ValueProps } from "./ValueProps";

interface MainHeroProps {
  heading: string;
  subheading: string;
  formTitle: string;
  formId: string;
}

export function MainHero({
  heading,
  subheading,
  formTitle,
  formId,
}: MainHeroProps) {
  return (
    <div
      className="pt-20 pb-16"
      style={{
        background: `
            radial-gradient(
              54.56% 38.14% at 32.93% 41.02%,
              rgba(255, 255, 255, 0.02) 0%,
              rgba(255, 255, 255, 0) 100%
            ),
            linear-gradient(93deg, #f2faff 2.27%, #d8ecf8 97.85%)
          `,
        backgroundBlendMode: "plus-lighter, normal",
      }}
    >
      <Container className="!max-w-marketing-content">
        <div className="grid grid-cols-1 gap-12 py-12 md:px-6 lg:grid-cols-2 lg:gap-16">
          <div className="flex flex-col">
            <div
              className="text-4xl font-semibold text-[#005A9D] md:text-5xl/tight"
              style={{ fontFamily: HEADING_FONT }}
            >
              {heading}
            </div>
            <div className="mt-4 text-xl text-gray-700">{subheading}</div>
            <ValueProps />
          </div>

          <div className="flex items-center">
            <div className="h-full w-full rounded-2xl bg-white p-3 border-8 border-blue-500/20 shadow-xl shadow-blue-800/10">
              <Box
                fontWeight={600}
                fontSize={22}
                textAlign="center"
                py={3}
                className="bbs"
              >
                {formTitle}
              </Box>
              <FilloutStandardEmbed
                filloutId={formId}
                dynamicResize={true}
                inheritParameters
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
